import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Enkel markdown-rendering (rubriker, paragrafer, fetstil, punktlistor).
 * Används av alla CMS-drivna statiska sidor.
 */
export const renderMarkdown = (text) => {
  if (!text) return null;
  
  const lines = text.split('\n');
  const elements = [];
  let key = 0;
  
  for (const line of lines) {
    if (line.startsWith('### ')) {
      elements.push(<h3 key={key++} className="text-lg font-bold text-[#0F172A] mt-6 mb-2">{line.slice(4)}</h3>);
    } else if (line.startsWith('## ')) {
      elements.push(<h2 key={key++} className="text-xl font-bold text-[#0F172A] mt-8 mb-4">{line.slice(3)}</h2>);
    } else if (line.startsWith('# ')) {
      elements.push(<h1 key={key++} className="text-2xl font-bold text-[#0F172A] mt-8 mb-4">{line.slice(2)}</h1>);
    } else if (line.startsWith('**') && line.endsWith('**')) {
      elements.push(<p key={key++} className="font-bold text-[#0F172A] mt-4 mb-2">{line.slice(2, -2)}</p>);
    } else if (line.startsWith('- ')) {
      elements.push(<li key={key++} className="text-gray-600 ml-4">{line.slice(2)}</li>);
    } else if (line.trim() === '') {
      elements.push(<br key={key++} />);
    } else {
      elements.push(<p key={key++} className="text-gray-600 mb-2">{line}</p>);
    }
  }
  
  return elements;
};

/**
 * Laddningsindikator för statiska sidor.
 */
export const PageLoading = () => (
  <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
    <Loader2 className="h-8 w-8 animate-spin text-[#003B73]" />
  </div>
);
